import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as homeRoutes } from './home/routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';

import NervenetHome from './nervenet/Index.vue';
import NervenetSupervisor from './nervenet/Supervisor.vue';
import NervenetKnowledge from './nervenet/Knowledge.vue';
import NervenetKbSearch from './nervenet/KbSearch.vue';
import NervenetBooking from './nervenet/Booking.vue';
import NervenetCommerce from './nervenet/Commerce.vue';
import NervenetPricing from './nervenet/Pricing.vue';
import NervenetStay from './nervenet/Stay.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...homeRoutes,
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        {
          path: frontendURL('accounts/:accountId/agent'),
          name: 'nervenet_home',
          component: NervenetHome,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/supervisor'),
          name: 'nervenet_supervisor',
          component: NervenetSupervisor,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/pricing'),
          name: 'nervenet_pricing',
          component: NervenetPricing,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/knowledge'),
          name: 'nervenet_knowledge',
          component: NervenetKnowledge,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/kb-search'),
          name: 'nervenet_kb_search',
          component: NervenetKbSearch,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/booking/calendar'),
          name: 'nervenet_booking_calendar',
          component: NervenetBooking,
          props: { page: 'calendar' },
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/booking/business'),
          name: 'nervenet_booking_business',
          component: NervenetBooking,
          props: { page: 'business' },
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/commerce'),
          name: 'nervenet_commerce',
          component: NervenetCommerce,
          props: { page: 'orders' },
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/stay'),
          name: 'nervenet_stay',
          component: NervenetStay,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
  ],
};
